import Link from "@material-symbols/svg-500/rounded/link.svg?react";
import { memo } from "react";

import { IconCreator } from "./_utils/icon-creator";

import type { SVGIconProps } from "./_utils/icon-creator";

const LinkIcon = (props: SVGIconProps) => {
	const Icon = () => IconCreator({ ...props, svgIcon: Link });
	return <Icon />;
};

export default memo(LinkIcon);
